import React from 'react'

interface Code {
  code: string
  description?: string | null
}

const Code: React.FC<Code> = ({ code, description }) => {
  return (
    <span className="flex flex-col gap-y-0.5">
      <span className="font-medium">{code}</span>
      {!!description && (
        <span className="text-xs line-clamp-3 text-primary-500 dark:text-primary-400">
          {description}
        </span>
      )}
    </span>
  )
}

export default Code
